export const Brand = {
  Travelsphere: 'Travelsphere'
};